(function () {
  function hideWalletButtons() {
    const selectors = [
      '.shopify-payment-button',
      '.shopify-payment-button__wrapper',
      '.shopify-payment-button__button',
      '.additional-checkout-buttons',
      '.accelerated-checkout-button',
      'shopify-accelerated-checkout',
      'shop-pay-wallet-button',
      'shopify-payment-terms',
      '.dynamic-checkout__content'
    ];

    selectors.forEach((selector) => {
      document.querySelectorAll(selector).forEach((el) => {
        el.style.setProperty('display', 'none', 'important');
        el.style.setProperty('visibility', 'hidden', 'important');
        el.style.setProperty('opacity', '0', 'important');
        el.style.setProperty('height', '0', 'important');
        el.style.setProperty('overflow', 'hidden', 'important');
      });
    });
  }

  function initHideWalletButtons() {
    hideWalletButtons();

    const observer = new MutationObserver(() => {
      hideWalletButtons();
    });

    if (document.body) {
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }

    setInterval(hideWalletButtons, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHideWalletButtons);
  } else {
    initHideWalletButtons();
  }
})();